var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0833 3.41658L15.0723 3.42763C15.6891 4.22021 15.6333 5.36665 14.9048 6.09515C14.313 6.68689 13.3536 6.68689 12.7619 6.09515L12.5833 5.91658L9.98062 8.51929C10.6504 9.77933 10.4545 11.3787 9.39298 12.4403L9.00592 12.8273C8.68049 13.1528 8.15285 13.1528 7.82741 12.8273L6.75 11.7499L3.83333 14.6666L0.5 15.4999L1.33333 12.1666L4.25 9.24991L3.17259 8.1725C2.84715 7.84707 2.84715 7.31943 3.17259 6.99399L3.55964 6.60694C4.62119 5.54539 6.22058 5.34951 7.48062 6.01929L10.0833 3.41658L9.90476 3.23801C9.31303 2.64628 9.31303 1.68689 9.90476 1.09515C10.6333 0.366649 11.7797 0.310809 12.5723 0.927633L12.5833 0.91658L15.0833 3.41658Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/Pin.1c8c1769446c15907f06579a93df9ebb.svg";
export { ForwardRef as ReactComponent };